export const setUser = user => {
  return {
    type: 'SET_USER',
    payload: {
      currentUser: user 
    }      
  }
}
export const clearUser = () => {
  return {
    type: 'CLEAR_USER'
  }
}


// WEBPACK FOOTER //
// ./src/actions/userAction.js